import React, { Component } from 'react'

export default class PreferenceCategoryLayout extends Component {
  render() {
    return (
      <div>
        <div className='page-header'>
          <h1>Preference Categories</h1>
        </div>
        {this.props.children}
      </div>
    )
  }
}
